/** @format */

import { createSelector } from 'reselect';

const selectVoucher = (state) => state.voucher;

export const selectVoucherDate = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherDate
);

export const selectVoucherInvSegKeys = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherInvSegKeys
);

export const selectVoucherBatchCustomers = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherBatchCustomers
);

export const selectVoucherEmailStatus = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherEmailStatus
);

export const selectIsFetching = createSelector(
  [selectVoucher],
  (voucher) => voucher.isFetching
);

export const selectIsSending = createSelector(
  [selectVoucher],
  (voucher) => voucher.isSending
);

export const selectErrorMessage = createSelector(
  [selectVoucher],
  (voucher) => voucher.errorMessage
);

export const selectIsVoucherDateNull = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherDate === null
);

export const selectIsVoucherInvSegKeysEmpty = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherInvSegKeys.length === 0
);

export const selectIsVoucherBatchCustomersEmpty = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherBatchCustomers.length === 0
);

export const selectIsVoucherEmailStatusEmpty = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherEmailStatus.length === 0
);

export const selectVoucherSelectedKeys = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherSelectedKeys
);

export const selectVoucherSelectedCustomers = createSelector(
  [selectVoucher],
  (voucher) => voucher.voucherSelectedCustomers
);

export const selectVoucherSelectedInvSegKey = createSelector(
  [selectVoucher],
  (voucher) =>
    voucher.voucherInvSegKeys.filter((key) =>
      voucher.voucherSelectedKeys.includes(key.id)
    )
);
